import React from 'react';
import IncidentCard from 'components/Jornadas/IncidentCard';
import AvatarStatus from 'componentsv2/AvatarStatus/AvatarStatus';

export const positionsTableColumns = [
  {
    title: '#',
    dataIndex: 'rank',
  },
  {
    title: 'Equipo',
    dataIndex: 'name',
    render: (_, record) => (
      <div className="d-flex">
        <AvatarStatus src={record?.club?.avatar_url} name={`${record?.club?.name}`} />
      </div>
    ),
    sorter: {
      compare: (a, b) => {
        a = a.club.name.toLowerCase();
        b = b.club.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: 'PJ',
    dataIndex: 'total_matches',
  },
  {
    title: 'G',
    dataIndex: 'won_matches',
  },
  {
    title: 'E',
    dataIndex: 'draw_matches',
  },
  {
    title: 'P',
    dataIndex: 'lost_matches',
  },
  {
    title: 'DG',
    dataIndex: 'goal_difference',
  },
  {
    title: 'Pts',
    dataIndex: 'points',
  },
];

export const volleyballPositionsColumns = best_of => {
  return [
    {
      title: '#',
      dataIndex: 'rank',
    },
    {
      title: 'Equipo',
      dataIndex: 'name',
      render: (_, record) => (
        <div className="d-flex">
          <AvatarStatus src={record?.club?.avatar_url} name={`${record?.club?.name}`} />
        </div>
      ),
      sorter: {
        compare: (a, b) => {
          a = a.club.name.toLowerCase();
          b = b.club.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: 'Matches',
      children: [
        {
          title: 'Pts',
          dataIndex: 'points',
        },
        {
          title: 'T',
          render: (_, record) => record.won_matches + record.lost_matches,
        },
        {
          title: 'W',
          dataIndex: 'won_matches',
        },
        {
          title: 'L',
          dataIndex: 'lost_matches',
        },
      ],
    },
    {
      title: 'Result Details',
      children:
        best_of === 5
          ? [
              {
                title: '3-0',
                dataIndex: 'three_zero',
              },
              {
                title: '3-1',
                dataIndex: 'three_one',
              },
              {
                title: '3-2',
                dataIndex: 'three_two',
              },
              {
                title: '2-3',
                dataIndex: 'two_three',
              },
              {
                title: '1-3',
                dataIndex: 'one_three',
              },
              {
                title: '0-3',
                dataIndex: 'zero_three',
              },
            ]
          : [
              {
                title: '2-0',
                dataIndex: 'two_zero',
              },
              {
                title: '2-1',
                dataIndex: 'two_one',
              },
              {
                title: '1-2',
                dataIndex: 'one_two',
              },
              {
                title: '0-2',
                dataIndex: 'zero_two',
              },
            ],
    },
    {
      title: 'Points',
      children: [
        {
          title: 'W',
          dataIndex: 'points_for',
        },
        {
          title: 'L',
          dataIndex: 'points_against',
        },
        {
          title: 'Ratio',
          dataIndex: 'points_ratio',
        },
      ],
    },
    {
      title: 'Sets',
      children: [
        {
          title: 'W',
          dataIndex: 'sets_for',
        },
        {
          title: 'L',
          dataIndex: 'sets_against',
        },
        {
          title: 'Ratio',
          dataIndex: 'sets_ratio',
        },
      ],
    },
  ];
};

export const leadersTableColumns = [
  {
    title: 'Jugador',
    render: (_, record) => (
      <div className="d-flex">
        {record?.player?.user?.first_name && record?.player?.user?.last_name
          ? `${record?.player?.user?.first_name} ${record?.player?.user?.last_name} #${record?.player?.number} - ${record?.club?.name}`
          : `Jugador #${record?.player?.number} - ${record?.club?.name}`}
      </div>
    ),
  },
  {
    title: 'Total',
    dataIndex: 'goals_count',
  },
];

export const cardsTableColumns = [
  {
    title: 'Jugador',
    render: (_, record) => (
      <div className="d-flex">
        {record?.player?.user?.first_name && record?.player?.user?.last_name
          ? `${record?.player?.user?.first_name} ${record?.player?.user?.last_name} #${record?.player?.number} - ${record?.club?.name}`
          : `Jugador #${record?.player?.number} - ${record?.club?.name}`}
      </div>
    ),
  },
  {
    title: <IncidentCard color="yellow" />,
    dataIndex: 'yellow_count',
  },
  {
    title: <IncidentCard color="red" />,
    dataIndex: 'red_count',
  },
];

export const throwsBasketballColumns = [
  {
    title: 'Jugador',
    render: (_, record) => (
      <div className="d-flex">
        {record?.player?.user?.first_name && record?.player?.user?.last_name
          ? `${record?.player?.user?.first_name} ${record?.player?.user?.last_name} #${record?.player?.number} - ${record?.club?.name}`
          : `Jugador #${record?.player?.number} - ${record?.club?.name}`}
      </div>
    ),
  },
  {
    title: 'Cantidad',
    render: (_, record) => record.amount,
  },
];
